import { logout } from '../../features/account/accountSlice';
import { RESET_STATE } from '../../store/resetActions';
import { IS_IDENTITY_BUILD } from '../../config/retailIdentity';
import { retailSession } from './retailSession';

/** Ends the SPT session and clears the store, as a manual sign-out does. */
export function endSptSession(dispatch) {
  dispatch(logout({ reason: 'manual' }));
  dispatch({ type: RESET_STATE, payload: { logoutReason: 'manual' } });
}

/**
 * The person's sign-out. In the identity build it ends the identity session as well: the two
 * sessions are one person's, so neither may outlive the other on a shared browser.
 */
export function signOutEverywhere(dispatch, { identityBuild = IS_IDENTITY_BUILD, session = retailSession } = {}) {
  if (identityBuild) {
    session.signOut();
  }
  endSptSession(dispatch);
}
